import { boardShortsComponents } from './board-shorts.js';
import { drawstringComponents } from './drawstring.js';
import { leftLegComponents } from './left-leg.js';
import { leftThighBandComponents } from './left-thigh-band.js';
import { rightLegComponents } from './right-leg.js';
import { rightThighBandComponents } from './right-thigh-band.js';
import { rootEntityComponents } from './root-entity.js';
import { shortsComponents } from './shorts.js';
import { swimShortsComponents } from './swim-shorts.js';
import { volleyballShortsComponents } from './volleyball-shorts.js';
import { waistbandComponents } from './waistband.js';
import { withDesignComponents } from './with-design.js';
export const generatedComponents = [
    ...shortsComponents,
    ...rootEntityComponents,
    ...leftLegComponents,
    ...rightLegComponents,
    ...leftThighBandComponents,
    ...rightThighBandComponents,
    ...waistbandComponents,
    ...drawstringComponents,
    ...swimShortsComponents,
    ...boardShortsComponents,
    ...volleyballShortsComponents,
    ...withDesignComponents
];

//# sourceMappingURL=index.js.map